import { CrfVersion } from './CrfVersion';
import type {
  CommentOrdering,
  NarrativeLayout,
  WorkspaceVariant,
} from './types';

export class Crf20262029 extends CrfVersion {
  readonly code = 'CRF 2026-2029';

  get workspaceVariant(): WorkspaceVariant {
    return 'acr2023';
  }

  get narrativeLayout(): NarrativeLayout {
    return 'multi-narrative';
  }

  get commentOrdering(): CommentOrdering {
    return 'multi-narrative-grouped';
  }

  get viewCommentsLabel(): string {
    return 'View all narratives and comments';
  }
}
